<!--- COMPONENTE PCParteProduccionNumeroTrabajadores  ---->
<!---
Descripción del componente:
---------------------------

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="div-componentePCParteProduccionNumeroTrabajadores">
    <!-----  LINEA PRODUCCIÓN CON TRABAJADORES MANUALES ----->
    <div
      v-if="lineaProduccionSeleccionada != null && lineaProduccionSeleccionada.UsoNumTrabajadoresManual"
      class="display-flex flex-direction-column align-items-center"
    >
      <div
        class="div-indicadorNumeroTrabajadoresParteProduccion"
      >
        <img
          alt="iconTrabajador"
          align="right"
          src="@/static/icons/ic_workers_yellow_indicator.svg"
          class="img-indicadorNumeroTrabajadoresParteProduccion"
        >
        <span
          class="span-indicadorNumeroTrabajadores"
        >  {{ numeroTrabajadoresParteProduccionSeleccionado }} </span>
      </div>

      <div
        v-show="habilitarEdicion"
        class="div-cambioNumeroTrabajadoresLinea display-flex flex-direction-column align-items-center"
      >
        <div class="div-tituloNuevoNumeroTrabajadores">
          <small class="span-texto-gris-14-500">Nuevo número de trabajadores linea: </small>
        </div>
        <f7-stepper
          large
          fill
          :value="nuevoNumeroTrabajadoresParteProduccionSeleccionado"
          :min="0"
          @input="nuevoNumeroTrabajadoresParteProduccionSeleccionado = $event.target.value"
        />
        <f7-row class="row-datosDeFechaHoraInicio padding-top-half">
          <f7-col width="50">
            <UCDatePicker
              :id="`uc-date-picker-${idComponente}`"
              :title="$t('production.common.startDate')"
              @onchange="CambiarFechaEntradaNuevoNumeroTrabajadores"
            />
          </f7-col>
          <f7-col width="50">
            <UCTimePicker
              :id="`uc-time-picker-${idComponente}`"
              ref="componenteTimePickerFechaNuevoIntervalo"
              :title="$t('production.common.startTime')"
              template="P2"
              @onchange="CambiarHoraEntradaNuevoNumeroTrabajadores"
            />
          </f7-col>
        </f7-row>
      </div>
    </div>
    <!----------- ÚLTIMOS REGISTROS NÚMEROS TRABAJADORES PARTE PRODUCCIÓN --------------->
    <div
      class="div-ultimosRegistrosTrabajadores"
      :class="{ 'div-ultimosRegistrosTrabajadores-sinEdicion': !habilitarEdicion }"
    >
      <div>
        <div class="div-tituloUltimosReistrosTrabajadores">
          <div class="div-elementoSeparador-total" />
          <span class="span-texto-azulOscuro-18-500">{{ $t('UltimosRegistrosTrabajadoresParteProduccion') }}</span>
          <div class="div-elementoSeparador-total" />
        </div>
        <UCPreload :show="mostrarPrecargaRegistrosNumeroTrabajadores" />
        <f7-col width="100">
          <f7-row
            v-for="(registro) in lstParteProduccionNumeroTrabajadores"
            :key="registro.Id"
            class="div-registro"
          >
            <f7-col
              width="5"
              class="col-indicadorEstado"
            >
              <span
                v-if="!EsIntervaloActivo(registro)"
                class="inidicador-azul-8"
              />
              <span
                v-if="EsIntervaloActivo(registro)"
                class="inidicador-verde-8"
              />
            </f7-col>
            <f7-col
              width="15"
              class="div-registro-columna"
            >
              <span
                class="span-texto-gris-16-500"
              >{{ FormatearFecha(registro.Fecha) }} </span>
            </f7-col>
            <f7-col
              width="25"
              class="div-registro-columna"
            >
              <span
                class="span-texto-gris-16-500"
              > {{ `${$t('production.common.startTime')}: ${FormatearHoraYMinutos(registro.HoraInicio)}` }} </span>
            </f7-col>
            <f7-col
              width="25"
              class="div-registro-columna"
            >
              <span
                v-if="!EsFechaNula(registro.HoraFin)"
                class="span-texto-gris-16-500"
              >  {{ `${$t('production.common.endTime')}: ${FormatearHoraYMinutos(registro.HoraFin)}` }}
              </span>
            </f7-col>
            <f7-col
              class="div-registro-columna"
              width="15"
            >
              <div>
                <img
                  alt="iconTrabajador"
                  src="@/static/icons/ic_workers_yellow_indicator.svg"
                  class="img-indicadorNumeroTrabajadoresParteProduccionPequeño"
                >
                <span
                  class="cantidadTrabajadores"
                >  {{ registro.NumeroTrabajadores }} </span>
              </div>
            </f7-col>
            <f7-col
              class="div-registro-columna"
              width="10"
            >
              <img
                alt="iconDelete"
                src="@/static/icons/ic_delete.svg"
                class="img-btn-eliminarRegistroNumeroTrabajadores"
                @click="SolicitudEliminarRegistroNumeroTrabajadores(registro)"
              >
            </f7-col>
          </f7-row>
        </f7-col>
      </div>
    </div>
    <!-- Botones aceptar confirmar -->

    <div class="div-elementoSeparador-90 div-separador" />
    <div class="div-opcionesActions">
      <f7-row>
        <f7-col
          width="50"
          class="col-izquierdaActions"
        >
          <a
            class="link link-izquierdaActions-2"
            @click="Cancelar()"
          > {{ $t('common.cancel').toUpperCase() }}</a>
        </f7-col>
        <f7-col
          width="50"
          class="col-derechaActions"
        >
          <a
            class="link link-derechaActions-2"
            @click="Confirmar()"
          > {{ $t('common.confirm').toUpperCase() }} </a>
        </f7-col>
      </f7-row>
    </div>

    <UCConfirmation ref="componenteConfirmacionEliminarIntervaloNumeroTrabajadores" />
    <!-- Action Confirmación Eliminar Intervalo número trabajadores -->
    <!-- <UCConfirmacionGH
      ref="componenteConfirmacionEliminarIntervaloNumeroTrabajadores"
      :abierto="actionConfirmarEliminarIntervaloTrabajadores"
      titulo="ELIMINAR INTERVALO NÚMERO TRABAJADORES"
      mensaje="¿Estas seguro que quieres eliminar el intervalo de trabajadores seleccionado?"
      @Confirmar="EliminarRegistroNumeroTrabajadores()"
      @Cancelar="actionConfirmarEliminarIntervaloTrabajadores = false"
    /> -->
  </div>
</template>

<script>
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';

import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import UCPreload from '@/components/common/UCPreload.vue';

export default {
  name: 'PCParteProduccionNumeroTrabajadores',
  components: {
    UCDatePicker,
    UCTimePicker,
    UCConfirmation,
    UCPreload,
  },
  props: {
    idComponente: {
      type: String,
      default: 'PCParteProduccionNumeroTrabajadores-0',
    },
    activo: {
      type: Boolean,
      default: false,
    },
    lineaProduccionSeleccionada: {
      type: Object,
      default: null,
    },
    lineaPedidoVentaSeleccionada: {
      type: Object,
      default: null,
    },
    parteProduccion: {
      type: Object,
      default: null,
    },
    habilitarEdicion: {
      type: Boolean,
      default: true,
    },
  },

  emits: [
    'Cancelar',
    'Confirmar',
  ],

  data() {
    return {
      lstParteProduccionNumeroTrabajadores: [], // Intervalos manuales.
      parteProduccionNumeroTrabajadoresSeleccionado: null,
      numeroTrabajadoresParteProduccionSeleccionado: 0,
      nuevoNumeroTrabajadoresParteProduccionSeleccionado: 0,
      fechaHoraNuevoNumeroTrabajadores: null, // Si el usuario cambia los valores de fecha y hora se aplicaran esos nuevos valores, por defecto tomara la fecha y hora actual.
      mostrarPrecargaRegistrosNumeroTrabajadores: false,
      // actionConfirmarEliminarIntervaloTrabajadores: false, // Controla la apertura del action de confirmación.
    };
  },

  watch: {
    activo(val) {
      if (val) {
        this.$refs.componenteTimePickerFechaNuevoIntervalo.SetTime(new Date()); // Sincronizamos la hora de los imput time picker con la actual.
      }
    },
    lineaPedidoVentaSeleccionada(val) {
      if (this.activo && val != null) {
        // this.InicializarComponente();
      }
    },
    parteProduccion(val) {
      if (val != null) {
        this.InicializarComponente();
      }
    },
  },

  methods: {
    InicializarComponente() {
      Log(this, 'PCParteProduccionNumeroTrabajadores->InicializarComponente');
      this.lstParteProduccionNumeroTrabajadores = [];
      if (this.lineaProduccionSeleccionada.UsoNumTrabajadoresManual) {
        this.ObtenerNumeroTrabajadoresLineaPedidoEnProduccion();
        this.ObtenerIntervalosNumeroTrabajadoresLineaPedidoVentaProduccion();
      }
    },

    FormatearHoraYMinutos(fechaHora) {
      Log(this, 'PCParteProduccionNumeroTrabajadores->FormatearHoraYMinutos');
      return SoporteFechaYHora.ObtenerHorasYMinutosDeCadenaHora(SoporteFechaYHora.obtenerHHMMSS(fechaHora));
    },

    FormatearFecha(pfecha) {
      Log(this, 'PCParteProduccionNumeroTrabajadores->FormatearHoraYMinutos');
      return SoporteFechaYHora.ObtenerDiaMesAno(pfecha);
    },

    EsFechaNula(fecha) {
      return SoporteFechaYHora.EsFechaNula(fecha);
    },

    EsIntervaloActivo(objTrabajadorLineaProduccion) {
      const ahora = Date.now();
      const horaInicio = new Date(objTrabajadorLineaProduccion.HoraInicio);
      const horaFin = new Date(objTrabajadorLineaProduccion.HoraFin);
      if (horaInicio <= ahora && this.EsFechaNula(objTrabajadorLineaProduccion.HoraFin)) {
        return true;
      }
      if (horaInicio <= ahora && horaFin > ahora) {
        return true;
      }
      return false;
    },

    ObtenerNumeroTrabajadoresLineaPedidoEnProduccion() {
      const self = this;
      const momentoConsulta = `${SoporteFechaYHora.obtenerDDMMAA(Date())} ${SoporteFechaYHora.obtenerHHMMSS(Date())}`;
      this.Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion(this.lineaProduccionSeleccionada.Id, this.lineaPedidoVentaSeleccionada.Id, this.parteProduccion.Id, momentoConsulta)
        .then((result) => {
          self.numeroTrabajadoresParteProduccionSeleccionado = result;
        })
        .catch((result) => {
          HiNotification.Toast(result.Mensaje);
        });
    },

    ObtenerIntervalosNumeroTrabajadoresLineaPedidoVentaProduccion() {
      Log(this, 'PCParteProduccionNumeroTrabajadores->ObtenerIntervalosNumeroTrabajadoresLineaPedidoVentaProduccion');
      const self = this;
      this.mostrarPrecargaRegistrosNumeroTrabajadores = true;
      this.Conexion_ObtenerIntervalosNumeroTrabajadoresLineaPedidoVentaProduccion(this.lineaProduccionSeleccionada.Id, this.lineaPedidoVentaSeleccionada.Id, this.parteProduccion.Id)
        .then((result) => {
          self.lstParteProduccionNumeroTrabajadores = JSON.parse(result.Mensaje);
        })
        .catch((result) => {
          LogError(`ObtenerIntervalosNumeroTrabajadoresLineaPedidoVentaProduccion --> ERROR: ${result}`);
        }).finally(() => {
          self.mostrarPrecargaRegistrosNumeroTrabajadores = false;
        });
    },

    CambiarFechaEntradaNuevoNumeroTrabajadores(nuevoValor) {
      Log(this, `${this.CambiarFechaEntradaNuevoNumeroTrabajadores.name}: ${nuevoValor}`);
      if (this.fechaHoraNuevoNumeroTrabajadores == null) {
        this.fechaHoraNuevoNumeroTrabajadores = `${SoporteFechaYHora.obtenerDDMMAA(nuevoValor)} ${SoporteFechaYHora.obtenerHHMMSS(Date())}`;
      } else {
        this.fechaHoraNuevoNumeroTrabajadores = `${SoporteFechaYHora.obtenerDDMMAA(nuevoValor)} ${SoporteFechaYHora.obtenerHorasYMinutos(Date(this.fechaHoraNuevoNumeroTrabajadores))} `;
      }
    },

    CambiarHoraEntradaNuevoNumeroTrabajadores(nuevoValor) {
      Log(this, `${this.CambiarHoraEntradaNuevoNumeroTrabajadores.name}: ${nuevoValor}`);
      if (this.fechaHoraNuevoNumeroTrabajadores == null) {
        this.fechaHoraNuevoNumeroTrabajadores = `${SoporteFechaYHora.obtenerDDMMAA(Date())} ${nuevoValor}`;
      } else {
        this.fechaHoraNuevoNumeroTrabajadores = `${this.fechaHoraNuevoNumeroTrabajadores.split(' ')[0]} ${nuevoValor} `;
      }
    },

    Cancelar() {
      Log(this, this.Cancelar.name);
      this.$emit('Cancelar');
    },

    Confirmar() {
      Log(this, this.Confirmar.name);
      if (this.nuevoNumeroTrabajadoresParteProduccionSeleccionado === this.numeroTrabajadoresParteProduccionSeleccionado) {
        this.Cancelar();
        return;
      }
      let momento = `${SoporteFechaYHora.obtenerDDMMAA(Date())} ${SoporteFechaYHora.obtenerHHMMSS(Date())}`;
      if (this.fechaHoraNuevoNumeroTrabajadores != null) {
        momento = this.fechaHoraNuevoNumeroTrabajadores;
      }

      PreloaderGH(true, true, this.$t('ActualizandoNumeroDeTrabajadores'), '');
      this.Conexion_GuardarNumeroTrabajadoresLineaPedidoVentaProduccion(this.lineaProduccionSeleccionada.Id, this.lineaPedidoVentaSeleccionada.Id, this.parteProduccion.Id, this.nuevoNumeroTrabajadoresParteProduccionSeleccionado, momento).then((result) => {
        if (result.Valor) {
          PreloaderGH(false);
          this.$emit('Confirmar');
        } else {
          PreloaderGH(false);
          HiNotification.Toast(`${this.$t('ErrorAlCambiarElNumeroTrabajadores')}${result.Mensaje}`);
        }
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('common.checkYourConnection'));
          LogError(error);
        });
    },

    SolicitudEliminarRegistroNumeroTrabajadores(seleccion) {
      Log(this, 'UConfirmacionGH->SolicitudEliminarRegistroNumeroTrabajadores');
      this.parteProduccionNumeroTrabajadoresSeleccionado = seleccion;
      this.$refs.componenteConfirmacionEliminarIntervaloNumeroTrabajadores.create(
        'ELIMINAR INTERVALO NÚMERO TRABAJADORES',
        '¿Estas seguro que quieres eliminar el intervalo de trabajadores seleccionado?',
        this.EliminarRegistroNumeroTrabajadores(),
      );
      this.$refs.componenteConfirmacionEliminarIntervaloNumeroTrabajadores.show();
    },

    EliminarRegistroNumeroTrabajadores() {
      Log(this, 'UConfirmacionGH->EliminarRegistroNumeroTrabajadores');
      const self = this;
      PreloaderGH(true, true, this.$t('EliminandoIntervaloNumeroTrabajadores'), '');
      this.Conexion_EliminarIntervalo(this.lineaProduccionSeleccionada.Id, this.lineaPedidoVentaSeleccionada.Id, this.parteProduccion.Id, this.parteProduccionNumeroTrabajadoresSeleccionado.HoraInicio).then(() => {
        PreloaderGH(false);
        self.InicializarComponente();
        HiNotification.Toast(this.$t('IntervaloTrabajadoresEliminado'));
        this.$emit('Confirmar');
      }).catch((error) => {
        PreloaderGH(false);
        HiNotification.Toast(this.$t('IntervaloTrabajadoresNoPusoDerEliminado'));
        LogError(error);
      });
    },

    Conexion_GuardarNumeroTrabajadoresLineaPedidoVentaProduccion(idLineaProduccion, idLineaPedidoVenta, idParteProduccion, nuevoNumeroTrabajadores, momento) {
      Log(this, 'PCParteProduccionNumeroTrabajadores->Conexion_GuardarNumeroTrabajadoresLineaPedidoVentaProduccion');
      return new Promise((resolve, reject) => {
        ConexionTA.callGuardarNumeroTrabajadoresLineaPedidoVentaProduccion(idLineaProduccion, idLineaPedidoVenta, idParteProduccion, nuevoNumeroTrabajadores, momento)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, idLineaPedidoVenta, idParteProduccion, momento) {
      Log(this, 'PCParteProduccionNumeroTrabajadores->Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion');
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerNumeroDeTrabajadoresLineaPedidoVentaProduccion(idLineaProduccion, idLineaPedidoVenta, idParteProduccion, momento)
          .then((result) => {
            if (result.Valor) {
              resolve(result.Mensaje);
            } else {
              reject(result.Mensaje);
            }
          })
          .catch((error) => {
            PreloaderGH(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ObtenerIntervalosNumeroTrabajadoresLineaPedidoVentaProduccion(idLineaProduccion, idLineaPedidoVenta, idParteProduccion) {
      Log(this, 'FrmProductionPlanningStatus->Conexion_ObtenerIntervalosNumeroTrabajadoresLineaPedidoVentaProduccion');
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerIntervalosNumeroTrabajadoresLineaPedidoVentaProduccion(idLineaProduccion, idLineaPedidoVenta, idParteProduccion)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_EliminarIntervalo(idLineaProduccion, idLineaPedidoVenta, idParteProduccion, momento) {
      Log(this, 'FrmProductionPlanningStatus->Conexion_EliminarIntervalo');
      return new Promise((resolve, reject) => {
        ConexionTA.callEliminarIntervaloFuerzaTrabajo(idLineaProduccion, idLineaPedidoVenta, idParteProduccion, momento)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },
  },
};
</script>

<style scoped>
.div-indicadorNumeroTrabajadoresParteProduccion {
  position: relative;
  width: 50px;
  height: 50px;
  margin-top: 10px;
  margin-left: 50px;
}

.span-indicadorNumeroTrabajadores {
  position: absolute;
  color: #fff;
  font-size: 39px;
  font-weight: 600;
  line-height: 29px;
  left: 14px;
  top: 53px;
}

.img-indicadorNumeroTrabajadoresParteProduccion {
  width: 90px;
}

.img-indicadorNumeroTrabajadoresParteProduccionPequeño {
  width: 30px;
}

.div-cambioNumeroTrabajadoresLinea {
  margin-top: 41px;
  width: calc(100% - (var(--f7-typography-margin) * 3));
}

.div-separador {
  width: 94%;
  bottom: 45px;
  position: absolute;
}

.div-opcionesActions {
  width: 94%;
  bottom: 10px;
  position: absolute;
}

.div-tituloNuevoNumeroTrabajadores {
  padding-bottom: 13px;
}

.row-datosDeFechaHoraInicio {
  width: 100%;
}

.div-tituloUltimosReistrosTrabajadores {
  margin-top: 15px;
  margin-bottom: 10px;
  margin-right: 20px;
  background: var(--his-blueberry-mist);
}

.col-indicadorEstado {
  padding-top: 3px;
}

.div-registro {
  padding: 0;
}

.div-ultimosRegistrosTrabajadores {
  margin-left: 20px;
}

.div-ultimosRegistrosTrabajadores-sinEdicion {
  margin-top: 70px;
}

.cantidadTrabajadores {
  width: 100%;
  color: var(--his-steel-blue);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 41px;
  text-align: right;
}

.img-btn-eliminarRegistroNumeroTrabajadores {
  width: 36px;
  position: absolute;
  right: 25px;
}
</style>
